import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

const SyllabusTrackingReport = () => {
  const [lectures, setLectures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get("/api/admin/get-syllabus-tracking-report", { withCredentials: true })
      .then((res) => setLectures(res.data))
      .catch((err) => {
        console.error("Error fetching syllabus tracking report:", err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!lectures.length) return <div>No lectures found.</div>;

  // Define DataTable columns
  const columns = [
    { name: "TERM", selector: (row) => row.term, sortable: true },
    { name: "TEACHER", selector: (row) => row.teacher || "-", sortable: true },
    { name: "CLASS", selector: (row) => row.class, sortable: true },
    { name: "DIV", selector: (row) => row.division, sortable: true },
    { name: "SUBJECT", selector: (row) => row.subject, sortable: true },
    { name: "CHAPTER", selector: (row) => row.chapter, sortable: true }, // static for now
    {
      name: "TOTAL LECTURE FOR THE CHAPTER",
      selector: (row) => row.totalLectures,
      sortable: true,
      right: true,
    },
    {
      name: "TOPICS",
      cell: (row) => (
        <ol style={{ margin: 0, paddingLeft: "1.2rem" }}>
          {row.topics.map((topic, i) => (
            <li key={i}>
              {topic.title} -{" "}
              {new Date(topic.date).toLocaleDateString("en-GB")}
            </li>
          ))}
        </ol>
      ),
    },
    {
      name: "TOTAL LECTURE CONSUMED",
      selector: (row) => row.totalConsumed,
      sortable: true,
      right: true,
    },
    {
      name: "PENDING LECTURE COUNT",
      selector: (row) =>
        row.pending > 0 ? `+${row.pending}` : row.pending,
      sortable: true,
      right: true,
    },
  ];

  return (
    <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
      <div className="card-header py-2 px-3 bg-base border-bottom">
        <h6 className="mb-0">Syllabus Tracking Report</h6>
      </div>
      <div className="card-body p-3">
        <DataTable
          columns={columns}
          data={lectures}
          pagination
          highlightOnHover
          striped
          dense
          responsive
          
        />
      </div>
    </div>
  );
};

export default SyllabusTrackingReport;
